export const events = {
  eventsCardDurationText: 'durée',
  eventsSearchInputText: 'Recherche',
  eventsRegisteredToEventAlertTitle: 'Inscription réussie',
  eventsUnregisteredToEventAlertTitle: 'Désinscription réussie',
  eventsExternalRegistrationPopupTitle: 'Inscription',
  eventsExternalRegistrationPopupContent: 'Avez-vous été inscrit avec succès ?',
  eventsExternalRegistrationNoButtonTitle: 'Non',
  eventsExternalRegistrationYesButtonTitle: 'Oui',
  eventsCurtainCopyOptionTitle: 'Copier le lien',
  eventsCurtainFlagOptionTitle: 'Signaler le contenu',
  eventsLinkCopiedAlertText: 'Lien copié !',
  eventsCurtainAddToCalendOptionTitle: 'Ajouter au calendrier',
  eventdetailsAgendaButtonTitle: 'Agenda',
  eventdetailsOnMapButtonTitle: 'Sur la carte',
  eventdetailsOnlineLocationTitle: 'En ligne',
  eventdetailAmountsRegisteredText: 'Participants',
  eventdetailsSeeAllButtonTitle: 'Voir tout',
  eventdetailsRegisteredButtonTitle: 'Inscrit',
  eventdetailsRegisterButtonTitle: 'S`inscrire',
  eventdetailsRegisteredAlertText: 'Inscription réussie',
  eventdetailsUnregisteredAlertText: 'Désinscription réussie',
  eventdetailsAgendaTitle: 'Agenda',
  eventdetailsSeeAllRegisteredCurtainTitle: 'Utilisateurs inscrits',
  eventdetailsSpeakersCurtainTitle: 'Orateurs',
  eventdetailsSpeakersSectionTitle: 'Orateurs',
  eventdetailsSpeakersSectionSeeAllButtonTitle: 'Voir tout',
  eventdetailsCustomSectionSeeAllButtonTitle: 'Voir tout',
  eventdetailsCurtainCopyOptionTitle: 'Copier le lien',
  eventdetailsCurtainFlagOptionTitle: 'Signaler le contenu',
  eventsdetailsLinkCopiedAlertText: 'Lien copié !',
  eventdetailsCurtainAddToCalOptionTitle: 'Ajouter au calendrier',
  eventDetailsAddCalendarPopupTitle: 'Calendrier',
  eventdetailsAddCalendarPopupContent: 'Ajouter au calendrier ?',
  eventdetailsAddCalendarPopupNoButtonTitle: 'Non',
  eventdetailsAddCalendarPopupYesButtonTitle: 'Oui',
  eventdetailsSpeakerCurtainCopyOptionTitle: 'Copier le lien',
  eventdetailsSpeakerCurtainFlagOptionTitle: 'Signaler le contenu',
  eventsdetailsSpeakersLinkCopiedAlertText: 'Lien copié !',
  eventdetailsCustomSectionCurtainCopyOptionTitle: 'Copier le lien',
  eventdetailsCustomSectionCurtainFlagOptionTitle: 'Signaler le contenu',
  eventsFlag: 'Signaler',
  eventsJoin: 'Participer',
  eventdetailsCustomSectionLinkCopiedAlertText: 'Lien copié !',
  eventContentReported: 'Contenu signalé',
  eventsError: 'Quelque chose s`est mal passé !',
  eventdetailsExternalRegistrationPopupContent: 'Avez-vous été inscrit avec succès ?',
  eventdetailsExternalRegistrationNoButtonTitle: 'Non',
  eventdetailsExternalRegistrationYesButtonTitle: 'Oui',
  eventdetailsExternalRegistrationPopupTitle: 'Inscription',
  eventsCardRegisteredButtonTitle: 'Inscrit',
  eventsCardRegisterButtonTitle: 'S`inscrire',
  eventsJoinLink: 'Lien pour participer : [url]{link}[/url][br]',
  eventsGuest: 'Invité',
  eventsNoSessionInDay: 'Aucun événement ce jour-là.',
  eventsShowUpcomingEvent: 'Afficher l`événement à venir'
}
